import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

interface Product {
  id: number;
  name: string;
  category: string;
  image: string;
  description: string;
  weight: string;
  ingredients?: string;
  nutritionalInfo?: string;
  usage?: string;
  storage?: string;
}

const products: Product[] = [
  {
    id: 18,
    name: 'Achocolatado',
    category: 'bebidas',
    image: '/products/achocolatado.png',
    description: '50 porções de 160 ml',
    weight: '1,01kg',
    ingredients: 'Açúcar, cacau em pó, leite em pó, aromatizante, estabilizante lecitina de soja.',
    nutritionalInfo: 'Cada porção de 200ml contém aproximadamente 150 kcal, 6g de proteína, 25g de carboidratos.',
    usage: 'Dissolva 18g do produto em 200ml de leite frio ou quente. Misture bem até completa dissolução.',
    storage: 'Conservar em local seco e arejado, ao abrigo da luz solar. Após aberto, consumir em até 30 dias.'
  },
  {
    id: 3,
    name: 'Amaciante de Carnes',
    category: 'culinarios',
    image: '/products/amaciante-carnes.png',
    description: 'Amacia até 34 Kg de Carne',
    weight: '1,01kg',
    ingredients: 'Sal, enzimas proteolíticas, antiumectante dióxido de silício.',
    nutritionalInfo: 'Produto destinado ao processamento industrial, não possui valor nutricional significativo.',
    usage: 'Aplique 30g do produto para cada 1kg de carne. Deixe agir por 30 minutos antes do preparo.',
    storage: 'Manter em local seco e arejado, temperatura ambiente. Validade de 24 meses.'
  },
  {
    id: 4,
    name: 'Amido de Milho - 1 Kg',
    category: 'industrial',
    image: '/products/amido-milho-1kg.png',
    description: 'Variável conforme aplicação',
    weight: '1kg',
    ingredients: 'Amido de milho puro.',
    nutritionalInfo: 'Rico em carboidratos, fonte de energia. Cada 100g contém 381 kcal.',
    usage: 'Ideal para espessamento de molhos, sopas e sobremesas. Use conforme receita.',
    storage: 'Conservar em recipiente fechado, local seco. Validade de 24 meses.'
  },
  {
    id: 10,
    name: 'Amido de Milho - 200 g',
    category: 'industrial',
    image: '/products/amido-milho-200g.png',
    description: 'Variável conforme aplicação',
    weight: '200g',
    ingredients: 'Amido de milho puro.',
    nutritionalInfo: 'Rico em carboidratos, fonte de energia. Cada 100g contém 381 kcal.',
    usage: 'Ideal para espessamento de molhos, sopas e sobremesas. Use conforme receita.',
    storage: 'Conservar em recipiente fechado, local seco. Validade de 24 meses.'
  },
  {
    id: 39,
    name: 'Amido de Milho - 25 Kg',
    category: 'industrial',
    image: '/products/amido-milho-25kg.png',
    description: 'Variável conforme aplicação',
    weight: '25kg',
    ingredients: 'Amido de milho puro.',
    nutritionalInfo: 'Rico em carboidratos, fonte de energia. Cada 100g contém 381 kcal.',
    usage: 'Ideal para uso industrial em grande escala. Espessamento e texturização.',
    storage: 'Conservar em local seco, arejado e protegido de pragas. Validade de 24 meses.'
  },
  {
    id: 9,
    name: 'Amido de Milho - 500 g',
    category: 'industrial',
    image: '/products/amido-milho-500g.png',
    description: 'Variável conforme aplicação',
    weight: '500g',
    ingredients: 'Amido de milho puro.',
    nutritionalInfo: 'Rico em carboidratos, fonte de energia. Cada 100g contém 381 kcal.',
    usage: 'Ideal para espessamento de molhos, sopas e sobremesas. Use conforme receita.',
    storage: 'Conservar em recipiente fechado, local seco. Validade de 24 meses.'
  },
  {
    id: 5,
    name: 'Batata em Flocos',
    category: 'culinarios',
    image: '/products/batata-flocos.png',
    description: 'Variável conforme aplicação',
    weight: '500g',
    ingredients: 'Batata desidratada, antioxidante ácido cítrico.',
    nutritionalInfo: 'Fonte de carboidratos e potássio. Cada 100g contém 350 kcal.',
    usage: 'Hidrate com água quente na proporção 1:3. Ideal para purês e recheios.',
    storage: 'Manter em local seco e arejado. Após aberto, consumir em até 30 dias.'
  },
  {
    id: 41,
    name: 'Batata em Flocos - 20 Kg',
    category: 'culinarios',
    image: '/products/batata-flocos-20kg.png',
    description: 'Variável conforme aplicação',
    weight: '20kg',
    ingredients: 'Batata desidratada, antioxidante ácido cítrico.',
    nutritionalInfo: 'Fonte de carboidratos e potássio. Cada 100g contém 350 kcal.',
    usage: 'Ideal para uso industrial. Hidrate com água quente na proporção 1:3.',
    storage: 'Conservar em local seco, arejado e protegido de pragas. Validade de 24 meses.'
  },
  {
    id: 6,
    name: 'Caldo de Carne',
    category: 'culinarios',
    image: '/products/caldo-carne.png',
    description: '80 Litros',
    weight: '1,01kg',
    ingredients: 'Sal, realçador de sabor glutamato monossódico, extrato de carne, cebola, alho.',
    nutritionalInfo: 'Baixo valor calórico, rico em sódio. Cada 100ml contém 8 kcal.',
    usage: 'Dissolva 20g em 1 litro de água quente. Ideal para sopas, risotos e molhos.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 7,
    name: 'Caldo de Galinha',
    category: 'culinarios',
    image: '/products/caldo-galinha.png',
    description: '80 Litros',
    weight: '1,01kg',
    ingredients: 'Sal, realçador de sabor glutamato monossódico, extrato de frango, cebola, salsa.',
    nutritionalInfo: 'Baixo valor calórico, rico em sódio. Cada 100ml contém 6 kcal.',
    usage: 'Dissolva 12,5g em 1 litro de água quente. Perfeito para sopas e caldos.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 8,
    name: 'Caldo de Legumes',
    category: 'culinarios',
    image: '/products/caldo-legumes.png',
    description: '80 Litros',
    weight: '1,01kg',
    ingredients: 'Sal, realçador de sabor glutamato monossódico, extrato de legumes, cebola, cenoura.',
    nutritionalInfo: 'Baixo valor calórico, rico em sódio. Cada 100ml contém 5 kcal.',
    usage: 'Dissolva 12,5g em 1 litro de água quente. Ideal para pratos vegetarianos.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 24,
    name: 'Chantilly',
    category: 'sobremesas',
    image: '/products/chantilly.png',
    description: '4 Litros',
    weight: '500g',
    ingredients: 'Açúcar, gordura vegetal, leite em pó, estabilizantes, aromatizante.',
    nutritionalInfo: 'Alto valor energético. Cada 100g contém 420 kcal.',
    usage: 'Bata 125g do produto com 1 litro de leite gelado até formar picos.',
    storage: 'Conservar em local seco e fresco. Após preparo, manter refrigerado.'
  },
  {
    id: 25,
    name: 'Chocolate em Pó 32% Cacau',
    category: 'bebidas',
    image: '/products/chocolate-32.png',
    description: 'Variável de acordo com a aplicação',
    weight: '1,01kg',
    ingredients: 'Cacau em pó (32%), açúcar, leite em pó, aromatizante.',
    nutritionalInfo: 'Rico em antioxidantes. Cada 100g contém 380 kcal.',
    usage: 'Ideal para bebidas quentes e frias, bolos e sobremesas.',
    storage: 'Conservar em local seco, ao abrigo da luz. Validade de 12 meses.'
  },
  {
    id: 26,
    name: 'Chocolate em Pó 50% Cacau',
    category: 'bebidas',
    image: '/products/chocolate-50.png',
    description: 'Variável conforme aplicação',
    weight: '1,01kg',
    ingredients: 'Cacau em pó (50%), açúcar, leite em pó, aromatizante.',
    nutritionalInfo: 'Alto teor de cacau, rico em antioxidantes. Cada 100g contém 360 kcal.',
    usage: 'Sabor intenso, ideal para chocolates gourmet e bebidas especiais.',
    storage: 'Conservar em local seco, ao abrigo da luz. Validade de 12 meses.'
  },
  {
    id: 11,
    name: 'Creme de Cebola',
    category: 'culinarios',
    image: '/products/creme-cebola.png',
    description: '17 Litros',
    weight: '1,01kg',
    ingredients: 'Amido modificado, cebola desidratada, sal, leite em pó, temperos.',
    nutritionalInfo: 'Cada 100ml contém 45 kcal, 2g de proteína.',
    usage: 'Dissolva 60g em 1 litro de água quente. Mexa até engrossar.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 27,
    name: 'Curau com Leite',
    category: 'sobremesas',
    image: '/products/curau-leite.png',
    description: '45 porções de 80 ml',
    weight: '1kg',
    ingredients: 'Açúcar, amido de milho, leite em pó, aromatizante, corante.',
    nutritionalInfo: 'Cada porção contém 120 kcal, 3g de proteína.',
    usage: 'Dissolva o conteúdo em 3,6 litros de leite. Cozinhe mexendo até engrossar.',
    storage: 'Conservar em local seco. Após preparo, manter refrigerado por até 3 dias.'
  },
  {
    id: 28,
    name: 'Curau sem Leite',
    category: 'sobremesas',
    image: '/products/curau-sem-leite.png',
    description: '45 porções de 80 ml',
    weight: '1kg',
    ingredients: 'Açúcar, amido de milho, aromatizante, corante.',
    nutritionalInfo: 'Cada porção contém 100 kcal, baixo teor de gordura.',
    usage: 'Dissolva em 3,6 litros de água. Cozinhe mexendo até engrossar.',
    storage: 'Conservar em local seco. Após preparo, manter refrigerado por até 3 dias.'
  },
  {
    id: 45,
    name: 'Farinha Para Empanar Panko',
    category: 'industrial',
    image: '/products/farinha-panko.png',
    description: 'Variável conforme aplicação',
    weight: '1kg',
    ingredients: 'Farinha de trigo, fermento, sal.',
    nutritionalInfo: 'Cada 100g contém 350 kcal, 12g de proteína.',
    usage: 'Ideal para empanados crocantes. Passe o alimento na farinha antes de fritar.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 29,
    name: 'Flan',
    category: 'sobremesas',
    image: '/products/flan.png',
    description: '49 porções de 80 ml',
    weight: '500g',
    ingredients: 'Sabores: Baunilha, Chocolate, Morango',
    nutritionalInfo: '',
    usage: 'Dissolva em 4 litros de leite. Cozinhe mexendo até engrossar.',
    storage: 'Conservar em local seco. Após preparo, refrigerar por até 5 dias.'
  },
  {
    id: 40,
    name: 'Gelatina - 25 Kg',
    category: 'sobremesas',
    image: '/products/gelatina-25kg.png',
    description: '150 Litros',
    weight: '25kg',
    ingredients: 'Açúcar, gelatina, acidulante, aromatizante, corante.',
    nutritionalInfo: 'Cada 100ml contém 70 kcal, 1g de proteína.',
    usage: 'Para uso industrial. Dissolva 167g em 1 litro de água quente.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 30,
    name: 'Gelatina 1 Kg',
    category: 'sobremesas',
    image: '/products/gelatina-1kg.png',
    description: '82 porções de 80 ml',
    weight: '1kg',
    ingredients: 'Sabores: Abacaxi, Limão, Morango, Uva, Cereja e Framboesa',
    nutritionalInfo: '',
    usage: 'Dissolva 12g em 80ml de água quente, complete com água fria.',
    storage: 'Conservar em local seco. Após preparo, refrigerar por até 7 dias.'
  },
  {
    id: 31,
    name: 'Gelatina 500 g',
    category: 'sobremesas',
    image: '/products/gelatina-500g.png',
    description: '78 porções de 80 ml',
    weight: '500g',
    ingredients: 'Sabores: Abacaxi, Limão, Morango, Uva, Cereja e Framboesa',
    nutritionalInfo: '',
    usage: 'Dissolva 6,4g em 80ml de água quente, complete com água fria.',
    storage: 'Conservar em local seco. Após preparo, refrigerar por até 7 dias.'
  },
  {
    id: 32,
    name: 'Gelatina sem Sabor - 1 Kg',
    category: 'sobremesas',
    image: '/products/gelatina-sem-sabor-1kg.png',
    description: 'Variável conforme aplicação',
    weight: '1kg',
    ingredients: 'Gelatina bovina pura.',
    nutritionalInfo: 'Rica em colágeno. Cada 100g contém 335 kcal, 84g de proteína.',
    usage: 'Hidrate em água fria, depois dissolva em água quente. Use conforme receita.',
    storage: 'Conservar em local seco e arejado. Validade de 36 meses.'
  },
  {
    id: 33,
    name: 'Gelatina sem Sabor - 500 g',
    category: 'sobremesas',
    image: '/products/gelatina-sem-sabor-500g.png',
    description: 'Variável conforme aplicação',
    weight: '500g',
    ingredients: 'Gelatina bovina pura.',
    nutritionalInfo: 'Rica em colágeno. Cada 100g contém 335 kcal, 84g de proteína.',
    usage: 'Hidrate em água fria, depois dissolva em água quente. Use conforme receita.',
    storage: 'Conservar em local seco e arejado. Validade de 36 meses.'
  },
  {
    id: 38,
    name: 'Gelatina Zero Açúcares',
    category: 'sobremesas',
    image: '/products/gelatina-zero.png',
    description: 'Variável conforme aplicação',
    weight: '12g',
    ingredients: 'Sabores: Maçã Verde, Abacaxi, Limão, Morango e Uva',
    nutritionalInfo: '',
    usage: 'Dissolva em água quente, complete com água fria. Ideal para dietas.',
    storage: 'Conservar em local seco. Após preparo, refrigerar por até 7 dias.'
  },
  {
    id: 34,
    name: 'Maria Mole',
    category: 'sobremesas',
    image: '/products/maria-mole.png',
    description: '56 porções de 80 g',
    weight: '500g',
    ingredients: 'Açúcar, gelatina, clara de ovo desidratada, aromatizante.',
    nutritionalInfo: 'Cada porção contém 90 kcal, 2g de proteína.',
    usage: 'Bata com água conforme instruções da embalagem até formar espuma.',
    storage: 'Conservar em local seco. Após preparo, refrigerar por até 3 dias.'
  },
  {
    id: 12,
    name: 'Milanesa',
    category: 'culinarios',
    image: '/products/milanesa.png',
    description: '7 Kg de empanados (frango)',
    weight: '800g',
    ingredients: 'Farinha de rosca, temperos, sal, realçador de sabor.',
    nutritionalInfo: 'Cada 100g contém 380 kcal, 14g de proteína.',
    usage: 'Passe o alimento no ovo batido, depois na milanesa. Frite até dourar.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 13,
    name: 'Milanesa Panko (Temperada)',
    category: 'culinarios',
    image: '/products/milanesa-panko.png',
    description: '5,3 Kg de empanados',
    weight: '800g',
    ingredients: 'Farinha panko, temperos especiais, sal, páprica.',
    nutritionalInfo: 'Cada 100g contém 360 kcal, 12g de proteína.',
    usage: 'Empanado crocante especial. Passe no ovo e depois na farinha panko.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 46,
    name: 'Mistura Para Tempura',
    category: 'industrial',
    image: '/products/mistura-tempura.png',
    description: 'Variável conforme aplicação',
    weight: '500g',
    ingredients: 'Farinha de trigo, amido de milho, fermento, sal.',
    nutritionalInfo: 'Cada 100g contém 340 kcal, 8g de proteína.',
    usage: 'Misture com água gelada até formar massa lisa. Ideal para tempurá.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 14,
    name: 'Molho Branco (Bechamel)',
    category: 'culinarios',
    image: '/products/molho-branco.png',
    description: '5 Litros',
    weight: '500g',
    ingredients: 'Amido modificado, leite em pó, sal, temperos, realçador de sabor.',
    nutritionalInfo: 'Cada 100ml contém 65 kcal, 3g de proteína.',
    usage: 'Dissolva 200g em 1 litro de leite quente. Mexa até engrossar.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 15,
    name: 'Molho Escuro',
    category: 'culinarios',
    image: '/products/molho-escuro.png',
    description: '5 Litros',
    weight: '500g',
    ingredients: 'Amido modificado, extrato de carne, sal, corante caramelo, temperos.',
    nutritionalInfo: 'Cada 100ml contém 55 kcal, 2g de proteína.',
    usage: 'Dissolva 200g em 1 litro de água quente. Mexa até engrossar.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 35,
    name: 'Mousse',
    category: 'sobremesas',
    image: '/products/mousse.png',
    description: '50 porções de 80 ml',
    weight: '500g',
    ingredients: 'Sabores: Chocolate Branco, Chocolate, Morango, Limão, Maracujá',
    nutritionalInfo: '',
    usage: 'Bata com leite gelado até formar espuma consistente.',
    storage: 'Conservar em local seco. Após preparo, refrigerar por até 5 dias.'
  },
  {
    id: 42,
    name: 'Proteína de Soja Texturizada - 15 Kg',
    category: 'industrial',
    image: '/products/proteina-soja-15kg.png',
    description: '45 Kg (após hidratada)',
    weight: '15kg',
    ingredients: 'Proteína de soja texturizada.',
    nutritionalInfo: 'Rica em proteínas. Cada 100g contém 350 kcal, 50g de proteína.',
    usage: 'Hidrate com água quente por 15 minutos. Use como substituto da carne.',
    storage: 'Conservar em local seco, arejado e protegido de pragas. Validade de 12 meses.'
  },
  {
    id: 16,
    name: 'Proteína Texturizada de Soja',
    category: 'industrial',
    image: '/products/proteina-soja.png',
    description: '1,5 Kg (após hidratada)',
    weight: '500g',
    ingredients: 'Proteína de soja texturizada.',
    nutritionalInfo: 'Rica em proteínas. Cada 100g contém 350 kcal, 50g de proteína.',
    usage: 'Hidrate com água quente por 15 minutos. Use como substituto da carne.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 36,
    name: 'Pudim com Leite',
    category: 'sobremesas',
    image: '/products/pudim-leite.png',
    description: '43 porções de 80 ml',
    weight: '1kg',
    ingredients: 'Sabores: Chocolate, Morango, Coco (Manjar), Baunilha',
    nutritionalInfo: '',
    usage: 'Dissolva em leite quente, cozinhe mexendo até engrossar.',
    storage: 'Conservar em local seco. Após preparo, refrigerar por até 5 dias.'
  },
  {
    id: 37,
    name: 'Pudim sem Leite',
    category: 'sobremesas',
    image: '/products/pudim-sem-leite.png',
    description: '69 porções de 80 ml',
    weight: '1kg',
    ingredients: 'Sabores: Chocolate, Morango, Coco (Manjar), Baunilha',
    nutritionalInfo: '',
    usage: 'Dissolva em água quente, cozinhe mexendo até engrossar.',
    storage: 'Conservar em local seco. Após preparo, refrigerar por até 5 dias.'
  },
  {
    id: 17,
    name: 'Purê de Batatas',
    category: 'culinarios',
    image: '/products/pure-batatas.png',
    description: '4 Kg',
    weight: '800g',
    ingredients: 'Batata desidratada, leite em pó, sal, temperos.',
    nutritionalInfo: 'Cada 100g contém 320 kcal, 8g de proteína.',
    usage: 'Dissolva 250g em 1 litro de água quente. Mexa até formar purê.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 20,
    name: 'Refresco 10 Litros - 1 Kg',
    category: 'bebidas',
    image: '/products/refresco-10l-1kg.png',
    description: '10 Litros',
    weight: '1kg',
    ingredients: 'Sabores: Abacaxi, Laranja, Limão, Maracujá, Morango, Tangerina e Uva',
    nutritionalInfo: '',
    usage: 'Dissolva 100g em 1 litro de água gelada. Mexa bem.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 19,
    name: 'Refresco 10 Litros - 200 g',
    category: 'bebidas',
    image: '/products/refresco-10l-200g.png',
    description: '10 Litros',
    weight: '200g',
    ingredients: 'Sabores: Maçã Verde, Jabuticaba, Abacaxi, Laranja, Limão, Maracujá, Morango, Tangerina e Uva',
    nutritionalInfo: '',
    usage: 'Dissolva 20g em 1 litro de água gelada. Mexa bem.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 21,
    name: 'Refresco 25 Litros - 1 Kg',
    category: 'bebidas',
    image: '/products/refresco-25l-1kg.png',
    description: '25 Litros',
    weight: '1kg',
    ingredients: 'Sabores: Abacaxi, Acerola, Caju, Goiaba, Guaraná, Laranja, Limão, Maracujá, Morango, Tangerina e Uva',
    nutritionalInfo: '',
    usage: 'Dissolva 40g em 1 litro de água gelada. Mexa bem.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 23,
    name: 'Refresco 25 Litros - 250 g',
    category: 'bebidas',
    image: '/products/refresco-25l-250g.png',
    description: '25 Litros',
    weight: '250g',
    ingredients: 'Sabores: Maçã Verde, Jabuticaba, Abacaxi, Caju, Laranja, Limão, Maracujá, Morango, Tangerina e Uva',
    nutritionalInfo: '',
    usage: 'Dissolva 10g em 1 litro de água gelada. Mexa bem.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  },
  {
    id: 22,
    name: 'Refresco 25 Litros - 500 g',
    category: 'bebidas',
    image: '/products/refresco-25l-500g.png',
    description: '25 Litros',
    weight: '500g',
    ingredients: 'Sabores: Maçã Verde, Jabuticaba, Abacaxi, Acerola, Caju, Goiaba, Guaraná, Laranja, Limão, Manga, Morango, Maracujá, Tangerina e Uva',
    nutritionalInfo: '',
    usage: 'Dissolva 20g em 1 litro de água gelada. Mexa bem.',
    storage: 'Conservar em local seco e arejado. Validade de 12 meses.'
  }
];

export default function Produtos() {
  const [activeCategory, setActiveCategory] = useState('todos');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const categories = [
    { id: 'todos', name: 'Todos os Produtos' },
    { id: 'culinarios', name: 'Culinários' },
    { id: 'sobremesas', name: 'Sobremesas' },
    { id: 'bebidas', name: 'Bebidas' },
    { id: 'industrial', name: 'Linha Industrial' }
  ];

  const heroImages = [
    'https://readdy.ai/api/search-image?query=professional%20beef%20steak%20with%20caramelized%20onions%20on%20white%20plate%2C%20commercial%20kitchen%20preparation%2C%20tender%20juicy%20meat%2C%20restaurant%20quality%20dish%2C%20garnished%20with%20herbs%2C%20elegant%20food%20presentation&width=1920&height=600&seq=heroRecipe1&orientation=landscape',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/529d0bb7f28f008b9ea8a45e174a1a1b.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/de3858094d83a0465772f73fe8a53a3f.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/9c226a1244e6906d1484daee33d12f12.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/c1a7f8a47073d8ff56e6a5ccc9de89a2.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/d9e752c386a1096ced1b32f89e448945.png'
  ];

  // Auto-rotate images
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, [heroImages.length]);

  const filteredProducts = products.filter(product => {
    const matchesCategory = activeCategory === 'todos' || product.category === activeCategory;
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         product.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
  };

  const openProductModal = (product: Product) => {
    setSelectedProduct(product);
  };

  const closeProductModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section with Rotating Images */}
      <section className="relative py-32 overflow-hidden">
        {/* Image Carousel */}
        <div className="absolute inset-0">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentImageIndex ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <div
                className="w-full h-full bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${image}')`
                }}
              />
            </div>
          ))}
        </div>
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-black/30"></div>
        
        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Nossos Produtos
          </h1>
          <p className="text-xl md:text-2xl text-red-100 max-w-3xl mx-auto">
            Descubra nossa linha completa de produtos para food service, desenvolvidos com a mais alta qualidade
          </p>
        </div>

        {/* Image Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
          <div className="flex space-x-2">
            {heroImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentImageIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentImageIndex 
                    ? 'bg-white scale-125' 
                    : 'bg-white/50 hover:bg-white/75'
                }`}
              />
            ))}
          </div>
        </div>
      </section>

      <main className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Search and Filter Section */}
          <div className="mb-12">
            <form onSubmit={handleSearch} className="max-w-2xl mx-auto mb-8">
              <div className="flex gap-4">
                <div className="flex-1 relative">
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Pesquisar produtos..."
                    className="w-full px-6 py-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-4 focus:ring-red-300 text-lg"
                  />
                  <i className="ri-search-line absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                </div>
                <Button type="submit" size="lg">
                  Buscar
                </Button>
              </div>
            </form>

            {/* Category Filter */}
            <div className="flex flex-wrap justify-center gap-4" data-product-shop>
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setActiveCategory(category.id)}
                  className={`px-6 py-3 rounded-full font-medium transition-all duration-200 whitespace-nowrap ${
                    activeCategory === category.id
                      ? 'bg-red-600 text-white shadow-lg'
                      : 'bg-white text-gray-700 hover:bg-red-50 hover:text-red-600 shadow-md border border-gray-200'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8" data-product-shop>
            {filteredProducts.map((product) => (
              <Card key={product.id} hover className="group cursor-pointer">
                <div 
                  className="aspect-square mb-4 overflow-hidden rounded-lg bg-gray-100 cursor-pointer"
                  onClick={() => openProductModal(product)}
                >
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.onerror = null;
                      target.src = `https://placehold.co/400x400/ef4444/ffffff?text=${encodeURIComponent(product.name)}`;
                    }}
                  />
                </div>
                
                <div className="space-y-3">
                  <h3 className="font-semibold text-lg text-gray-900 group-hover:text-red-600 transition-colors">
                    {product.name}
                  </h3>
                  
                  <p className="text-gray-600 text-sm line-clamp-2">
                    {product.description}
                  </p>
                  
                  <div className="flex items-center justify-between">
                    <div>
                      <span className="text-sm text-gray-500">{product.weight}</span>
                    </div>
                  </div>
                  
                  <div className="flex gap-2">
                    <Button 
                      variant="outline" 
                      size="sm" 
                      className="w-full"
                      onClick={() => openProductModal(product)}
                    >
                      Ver Detalhes
                    </Button>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-2xl font-semibold text-gray-600 mb-2">Nenhum produto encontrado</h3>
              <p className="text-gray-500">Tente ajustar os filtros ou termo de busca</p>
            </div>
          )}

          {/* Call to Action */}
          <div className="text-center mt-16 bg-gray-50 rounded-2xl p-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Não encontrou o que procura?
            </h3>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Entre em contato conosco e nossa equipe especializada te ajudará a encontrar a solução ideal
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                size="lg"
                onClick={() => {
                  const form = document.createElement('form');
                  form.style.display = 'none';
                  form.setAttribute('data-readdy-form', '');
                  form.action = 'https://readdy.ai/api/form/d3m055a2otq89lvpsf50';
                  form.method = 'POST';
                  
                  const nameInput = document.createElement('input');
                  nameInput.name = 'nome';
                  nameInput.value = 'Contato via botão - Falar com Especialista';
                  
                  const messageInput = document.createElement('input');
                  messageInput.name = 'mensagem';
                  messageInput.value = 'Cliente interessado em falar com especialista sobre produtos';
                  
                  form.appendChild(nameInput);
                  form.appendChild(messageInput);
                  document.body.appendChild(form);
                  
                  const data = new URLSearchParams();
                  data.append('nome', nameInput.value);
                  data.append('mensagem', messageInput.value);
                  
                  fetch('https://readdy.ai/api/form/d3m055a2otq89lvpsf50', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: data
                  }).then(response => {
                    if (response.ok) {
                      alert('Solicitação enviada! Nossa equipe entrará em contato em breve.');
                    } else {
                      alert('Erro ao enviar solicitação. Tente novamente.');
                    }
                  }).catch(() => {
                    alert('Erro ao enviar solicitação. Verifique sua conexão.');
                  });
                  
                  document.body.removeChild(form);
                }}
              >
                <i className="ri-phone-line mr-2"></i>
                Falar com Especialista
              </Button>
              <Button variant="outline" size="lg">
                <i className="ri-mail-line mr-2"></i>
                Enviar Mensagem
              </Button>
            </div>
          </div>

        </div>
      </main>

      {/* Product Detail Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
              <h2 className="text-2xl font-bold text-gray-900">{selectedProduct.name}</h2>
              <button
                onClick={closeProductModal}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>
            
            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Product Image */}
                <div className="aspect-square bg-gray-100 rounded-xl overflow-hidden">
                  <img
                    src={selectedProduct.image}
                    alt={selectedProduct.name}
                    className="w-full h-full object-contain"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.onerror = null;
                      target.src = `https://placehold.co/600x600/ef4444/ffffff?text=${encodeURIComponent(selectedProduct.name)}`;
                    }}
                  />
                </div>
                
                {/* Product Details */}
                <div className="space-y-6">
                  <div>
                    <span className="inline-block px-3 py-1 bg-red-100 text-red-800 text-sm font-medium rounded-full mb-3">
                      {categories.find(cat => cat.id === selectedProduct.category)?.name}
                    </span>
                    <h3 className="text-3xl font-bold text-gray-900 mb-2">{selectedProduct.name}</h3>
                    <p className="text-xl text-gray-600 mb-4">{selectedProduct.description}</p>
                    <p className="text-lg font-semibold text-red-600">Peso: {selectedProduct.weight}</p>
                  </div>

                  {/* Sabores (apenas se tiver sabores no campo ingredients) */}
                  {selectedProduct.ingredients && selectedProduct.ingredients.startsWith('Sabores:') && (
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-cake-line mr-2 text-green-600"></i>
                        Sabores
                      </h4>
                      <p className="text-gray-700 leading-relaxed">{selectedProduct.ingredients.replace('Sabores: ', '')}</p>
                    </div>
                  )}

                  {/* Ingredientes (apenas se NÃO tiver sabores) */}
                  {selectedProduct.ingredients && !selectedProduct.ingredients.startsWith('Sabores:') && (
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-leaf-line mr-2 text-green-600"></i>
                        Ingredientes
                      </h4>
                      <p className="text-gray-700 leading-relaxed">{selectedProduct.ingredients}</p>
                    </div>
                  )}

                  {/* Informações Nutricionais (apenas se tiver conteúdo) */}
                  {selectedProduct.nutritionalInfo && selectedProduct.nutritionalInfo.length > 0 && (
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-heart-pulse-line mr-2 text-red-600"></i>
                        Informações Nutricionais
                      </h4>
                      <p className="text-gray-700 leading-relaxed">{selectedProduct.nutritionalInfo}</p>
                    </div>
                  )}

                  {/* Usage */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                      <i className="ri-book-open-line mr-2 text-blue-600"></i>
                      Modo de Uso
                    </h4>
                    <p className="text-gray-700 leading-relaxed">{selectedProduct.usage}</p>
                  </div>

                  {/* Storage */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                      <i className="ri-archive-line mr-2 text-orange-600"></i>
                      Armazenamento
                    </h4>
                    <p className="text-gray-700 leading-relaxed">{selectedProduct.storage}</p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
